/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface ApiUserRequest
 */
export interface ApiUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUserRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiUserRequest
     */
    description?: string | null;
    /**
     * 
     * @type {Role}
     * @memberof ApiUserRequest
     */
    role: Role;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserRequest
     */
    superGroupIds?: Array<string>;
}

export function ApiUserRequestFromJSON(json: any): ApiUserRequest {
    return ApiUserRequestFromJSONTyped(json, false);
}

export function ApiUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'role': RoleFromJSON(json['role']),
        'superGroupIds': !exists(json, 'superGroupIds') ? undefined : json['superGroupIds'],
    };
}

export function ApiUserRequestToJSON(value?: ApiUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'description': value.description,
        'role': RoleToJSON(value.role),
        'superGroupIds': value.superGroupIds,
    };
}

